import { Box, Collapse, CollapsibleIconButton, IconButton, Stack, Switch, Typography } from '@chronosphereio/chrono-ui';
import { Close as CloseIcon } from 'mdi-material-ui';
import { ChangeEvent, useState } from 'react';
import { TimeSeriesChartYAxisOptions } from '@/core';
import { YAxisOptionsEditorControls } from '@/panels-plugin/plugins/time-series-chart/TimeSeriesChartPanelOptionsEditor/YAxisOptionsEditor';
import { OverrideOptionComponent } from '../types';

export const OverrideRightYAxis: OverrideOptionComponent<TimeSeriesChartYAxisOptions | undefined> = ({
  onChange,
  value,
  title,
  onRemove,
}) => {
  const handleShowChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ ...value, show: event.target.checked });
  };

  const handleChange = (options: TimeSeriesChartYAxisOptions) => {
    onChange(options);
  };

  const toggleOptions = () => {
    setShowAxisOptions((current) => !current);
  };

  const [showAxisOptions, setShowAxisOptions] = useState(false);

  return (
    <>
      <Stack direction="row" alignItems="center">
        <Box flexGrow={0}>
          <Typography variant="subtitle1">
            {title} <CollapsibleIconButton onClick={toggleOptions} collapsed={!showAxisOptions} />
          </Typography>
        </Box>

        <Box flexGrow={1}></Box>

        <Box flexGrow={0}>
          <Switch checked={value?.show === undefined ? true : value.show} onChange={handleShowChange} />
        </Box>

        <Box flexGrow={0}>
          <IconButton size="small" onClick={onRemove}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Stack>

      <Collapse in={showAxisOptions} timeout="auto">
        <Stack spacing={1} px={2}>
          <YAxisOptionsEditorControls
            value={value || {}}
            onChange={handleChange}
            includeShowOption={false}
            includeUnitSelector={true}
          />
        </Stack>
      </Collapse>
    </>
  );
};
